export default __webpack_public_path__ + "static/media/warning--no-passing-zone--g2.d2c6f7ce.png";